import { v4 as uuidv4 } from "uuid";

const menuData = () => {
  return [
    {
      item: null,
      subMenu: ["Accounts", "Offers", "Rewards", "More Services"],
      id: uuidv4(),
      index: 0,
    },
    {
      item: "Products",
      subMenu: ["Saving", "Spending", "Investing", "Borrowing"],
      id: uuidv4(),
      index: 1,
    },
    {
      item: "Ways to Bank",
      subMenu: ["Online Banking", "Money Management", "Mazuma Locations"],
      id: uuidv4(),
      index: 2,
    },

    {
      item: "Our Blog",
      subMenu: [""],
      id: uuidv4(),
      index: 3,
    },
    {
      item: "Contact",
      subMenu: ["Who We Are", "Partnerships", "Careers", "Contact Us"],
      id: uuidv4(),
      index: 4,
    },
  ];
};

export default menuData;
